export default "__VITE_ASSET__BD13Mir4__"